import { IScrollToActiveCardIdSetAction } from './types';
import { AT_SCROLL_TO_ACTIVE_CARD_ID } from './constants';

export const scrollToActiveCardIdlSet = (
    scrollToActiveCardId: boolean,
): IScrollToActiveCardIdSetAction => {
    return {
        type: AT_SCROLL_TO_ACTIVE_CARD_ID,
        scrollToActiveCardId,
    }
};
